// extracted by mini-css-extract-plugin
export default {"fullWidth":"panel-footer-primary-actions-module__fullWidth--e8L0l"};